let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iabLw")).then(() => parcelRequire('esKVw'));